import { supabase } from './supabase';

type LogLevel = 'info' | 'warning' | 'error';

interface LogEntry {
  action: string;
  entity_type: string;
  entity_id?: string;
  details?: Record<string, any>;
  level: LogLevel;
}

export const createLog = async ({
  action,
  entity_type,
  entity_id,
  details,
  level = 'info'
}: LogEntry) => {
  try {
    const { error } = await supabase
      .from('system_logs')
      .insert([{
        action,
        entity_type,
        entity_id,
        details,
        level
      }]);

    if (error) throw error;
  } catch (error) {
    console.error('Error creating log:', error);
  }
};